export enum RecurlyFields {
  FirstName = "first_name",
  LastName = "last_name",
  Email = "email",
  Number = "number",
  Month = "month",
  Year = "year",
  CVV = "cvv",
  Country = "country",
  Address = "address1",
  City = "city",
  State = "state",
  PostalCode = "postal_code",
}

export const REQUIRED_FIELDS = [RecurlyFields.CVV];
